import { CloseIcon } from "@bale/ui";
import styles from "./DismissibleHelp.module.scss";

interface Props {
  helpText: string;
  moreInfo?: {
    title: string;
    onClick: () => void;
  };
}
export function DismissibleHelp(props: Props) {
  const hasMoreInfo = !!props.moreInfo?.title;
  return (
    <div className={styles.HelperContainer}>
      <p className={styles.HelpText}>
        {props.helpText}
        {hasMoreInfo && (
          <span className={styles.MoreInfo} onClick={props.moreInfo?.onClick}>
            {" "}
            {props.moreInfo?.title}
          </span>
        )}
      </p>
    </div>
  );
}
